<template>
  <div class="crud form main-view">
    <el-form :model="model" :rules="rules" size="small" ref="form" v-loading="loading"
    :element-loading-text="loadingText" v-if="status === null" target="#app-main-content" label-position="top">
      <h2>{{ title }}</h2>
      <el-form-item label="Name" prop="name">
        <el-input v-model="model.name" placeholder="Name" />
      </el-form-item>
      <el-form-item label="Type" prop="type">
        <el-select v-model="model.type" placeholder="Select Type">
          <el-option v-for="item in botTypes" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>

      <div v-if="model.type === 'BotPlatform'">
        <h3>Configuración de BotPlatform</h3>
        <el-form-item label="URL">
          <el-input v-model="model.botPlatform.bot_platform_id" />
        </el-form-item>
      </div>

      <div v-if="model.type === 'LiveHelperChat'">
        <h3>Configuración de Live Helper Chat</h3>
        <div>
          <el-form-item label="URL">
            <el-input v-model="model.lhc.url"></el-input>
          </el-form-item>
          <el-form-item label="Department Id">
            <el-input v-model="model.lhc.dept_id"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="Username">
          <el-input v-model="model.lhc.username"></el-input>
        </el-form-item>
        <el-form-item label="Password">
          <el-input v-model="model.lhc.password"></el-input>
        </el-form-item>
      </div>

      <div>
        <h3>{{ $t('contact-me.chat-center.timeout-bot.title') }}</h3>
        <p style="font-size:14px">{{ $t('contact-me.chat-center.timeout-bot.description') }}</p>
        <el-form-item :label="$t('contact-me.chat-center.timeout-bot.timeoutBot')" prop="timeoutClient">
          <el-input type="number" v-model.number="model.timeoutClient"></el-input>
        </el-form-item>

        <el-form-item :label="$t('contact-me.chat-center.timeout-bot.message')" v-if="model.timeoutClient > 0">
          <el-input type="textarea" v-model="model.timeoutClientMessage"></el-input>
        </el-form-item>

        <el-form-item :label="$t('contact-me.chat-center.timeout-bot.timeoutBotTries')" prop="timeoutClientTries" v-if="model.timeoutClient > 0">
          <el-input type="number" v-model.number="model.timeoutClientTries"></el-input>
        </el-form-item>

        <el-form-item :label="$t('contact-me.chat-center.timeout-bot.action')" v-if="model.timeoutClient > 0">
          <el-select v-model="model.timeoutClientAction">
            <el-option v-for="option in timeoutClientActions" :key="option.id" :label="option.label"
              :value="option.value"></el-option>
          </el-select>
        </el-form-item>
      </div>

      <el-button size="small" @click="$router.go(-1)">{{ $t("common.cancel") }}</el-button>
      <el-button type="primary" size="small" @click="submit">{{ $t("common.save") }}</el-button>
    </el-form>
    <div class="message" v-else>
      <div>
        <img src="@/img/success.svg" v-if="status === 200" />
        <img src="@/img/error.svg" v-else />
        <p> {{ message }} </p>
        <div class="buttons">
          <el-button type="text" @click="$router.go(-1)">{{ $t("common.go-back-to-the-list") }}</el-button>
          <el-button type="text" @click="status = null" v-if="status !== 404">{{ $t("common.show-the-form")
            }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    entity: {
      required: false,
    },
    id: {
      required: false,
      type: String,
      default: "0"
    }
  },
  data () {
    return {
      rules: {
        name: [
          { required: true, message: this.$t("contact-me.chat-center.name-required"), trigger: "blur" },
        ],
        type: [
          { required: true, message: this.$t("contact-me.chat-center.name-required"), trigger: "blur" },
        ],
      },
      model: {
        name: this.entity?.name ?? "",
        type: this.entity?.type ?? "",
        timeoutClient: this.entity?.timeoutClient ?? 0,
        timeoutClientMessage: this.entity?.timeoutClientMessage ?? null,
        timeoutClientTries: this.entity?.timeoutClientTries ?? 0,
        timeoutClientAction: this.entity?.timeoutClientAction ?? null,
        lhc: {
          url: this.entity?.type === "LiveHelperChat" ? this.entity.config.url : "",
          username: this.entity?.type === "LiveHelperChat" ? this.entity.config.username : "",
          password: this.entity?.type === "LiveHelperChat" ? this.entity.config.password : "",
          dept_id: this.entity?.type === "LiveHelperChat" ? this.entity.config.dept_id : "",
        },
        botPlatform: {
          bot_platform_id: this.entity?.type === "BotPlatform" ? this.entity.config.bot_platform_id : "",
        }
      },
      botTypes: [
        { label: "Bot Platform", value: "BotPlatform" },
        { label: "Live Helper Chat", value: "LiveHelperChat" },
      ],
      timeoutClientActions: [
        { label: this.$t("contact-me.chat-center.timeout-bot.close-chat"), value: "close" },
        { label: this.$t("contact-me.chat-center.timeout-bot.nothing"), value: "nothing" },
      ],
      loading: false,
      status: null,
    }
  },
  methods: {
    submit () {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return
        }

        this.model.organization = this.$store.getters["contactMe/getOrganizationId"];
        let payload = this.model

        if (this.model.type === "LiveHelperChat") {
          payload = { ...this.model, ...this.model.lhc };
        } else {
          payload = { ...this.model, ...this.model.botPlatform };
        }

        if (payload.timeoutClient === 0) {
          payload.timeoutClientMessage = null;
          payload.timeoutClientTries = 0;
          payload.timeoutClientAction = null;
        }

        delete payload.lhc;
        delete payload.botPlatform;

        try {
          this.loading = true
          if (!this.edit) {
            await this.$store.dispatch("bots/create", payload)
          } else {
            await this.$store.dispatch("bots/update", {id: this.id, payload })
          }
          this.status = 200
        } catch {
          this.status = 400
        } finally {
          this.loading = false
        }
      });
    },
  },
  computed: {
    edit () {
      return parseInt(this.id) > 0
    },
    title () {
      return this.edit ? this.$t("contact-me.chat-center.edit-bot") : this.$t("contact-me.chat-center.new-bot")
    },
    message () {
      if (this.status === 200) {
        return this.$t("common.saved")
      }

      if (this.status === 404) {
        return this.$t("common.not-found")
      }

      return this.$t("common.not-saved")
    },
    loadingText () {
      return this.$t('common.saving')
    }
  }
}
</script>

<style scoped>
.message {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: space-around;
  text-align: center;
  width: 100%;
}

.buttons {
  display: flex;
  flex-direction: column;
}
</style>